import { defineMessages } from '@formatjs/intl';

const UTC_DATE_TIME_FORMATTER = new Intl.DateTimeFormat('en-US', {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
  timeZone: 'UTC',
  timeZoneName: 'short',
});

export const formatUtcDateTime = (value?: string | Date | null): string => {
  if (!value) return '';
  const date = new Date(value);

  return Number.isNaN(date.getTime())
    ? String(value)
    : UTC_DATE_TIME_FORMATTER.format(date);
};

export const isNullDate = (date: Date | string | null) =>
  date === '0000-00-00 00:00:00' ||
  date === '0000-00-00' ||
  date === '00:00:00' ||
  date === '00:00' ||
  date === null;

export const INDEXED_WEEK_DAYS = [
  { index: 0, day: 'Sunday' },
  { index: 1, day: 'Monday' },
  { index: 2, day: 'Tuesday' },
  { index: 3, day: 'Wednesday' },
  { index: 4, day: 'Thursday' },
  { index: 5, day: 'Friday' },
  { index: 6, day: 'Saturday' },
];

export const DAYS_OF_WEEK = [
  ...INDEXED_WEEK_DAYS.slice(1),
  INDEXED_WEEK_DAYS[0],
];

export const MAX_HOURS = 24.5;

export const MAX_HOURS_PER_DAY = 10;

export const DEFAULT_HOURS = [0, 0, 0, 0, 0, 0, 0];

// Maximum allowed schedule duration. Referenced by validation, Calendar UI, and builder.
// Change only here — all consumers import this constant.
export const MAX_SCHEDULE_MONTHS = 24;

enum DayIndex {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
}

export const intlFormattedDayOfWeek: {
  [index: number]: { id: string; defaultMessage: string };
} = defineMessages({
  [DayIndex.Sunday]: {
    id: 'days.sunday',
    defaultMessage: 'Sunday',
  },
  [DayIndex.Monday]: {
    id: 'days.monday',
    defaultMessage: 'Monday',
  },
  [DayIndex.Tuesday]: {
    id: 'days.tuesday',
    defaultMessage: 'Tuesday',
  },
  [DayIndex.Wednesday]: {
    id: 'days.wednesday',
    defaultMessage: 'Wednesday',
  },
  [DayIndex.Thursday]: {
    id: 'days.thursday',
    defaultMessage: 'Thursday',
  },
  [DayIndex.Friday]: {
    id: 'days.friday',
    defaultMessage: 'Friday',
  },
  [DayIndex.Saturday]: {
    id: 'days.saturday',
    defaultMessage: 'Saturday',
  },
});
